import { render, staticRenderFns } from "./addReferralBanner.vue?vue&type=template&id=184f0fbc&lang=pug"
import script from "./addReferralBanner.vue?vue&type=script&lang=js"
export * from "./addReferralBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports